import CarouselDisplay from './CarouselDisplay';

export default CarouselDisplay;
